<template>
  <div>
    <el-card
      class="box-card activity"
      shadow="hover"
      :body-style="{ padding: '0 20px 0 20px' }"
    >
      <div slot="header" class="clearfix stats">
        <div class="box title">FACTURAS Y PAGOS</div>
        <el-button type="text" class="box" @click="$emit('push-add')"
          ><i class="mdi mdi-plus-circle-outline" style="font-size: 24px"></i
        ></el-button>
      </div>
      <el-table
        :data="reportData"
        :show-header="false"
        style="width: 100%; padding-top: 20px"
      >
        <el-table-column prop="Title"> </el-table-column>

        <el-table-column prop="Qty" width="70" align="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleClickLink(scope.row)">
              {{ scope.row.Qty }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-drawer :visible.sync="drawer" :title="title" size="50%">
      <el-row class="rowHeader">
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="13">
              <p>Total a pagar:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalInvoices }}</strong>
              </p>
            </el-col>
          </el-row>

          <el-row
            class="internalRowHeader"
            v-if="
              title != 'Facturas del mes sin registrar' ||
              title != 'Facturas sin registrar meses anteriores'
            "
          >
            <el-col :span="13">
              <p>Pagado:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalPaymentsRecorded }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row class="internalRowHeader">
            <el-col :span="12">
              <p>Pendiente:</p>
            </el-col>
            <el-col :span="6">
              <p>
                <strong>{{ totalInvoicesNotRecorded }}</strong>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <yearcomponent
          @change="handler_year"
          v-model="year"
          v-if="title == 'Facturas del mes sin registrar'"
          class="collectionsFilter"
        >
        </yearcomponent>
        <monthcomponent
          @change="handler_month"
          v-model="month"
          v-if="title == 'Facturas del mes sin registrar'"
          class="collectionsFilter marginRight"
        >
        </monthcomponent>
      </el-row>
      <rabbey-table3
        :data="onTableData"
        :search="search"
        :columns="columns"
        :actions="ActionsInvoicesOrPayments"
        :row-class-name="tableRowClassName"
        :stripe="true"
        @rtable-push-action="handlePushAction"
        :max-height="700"
        :page-sizes="[10, 30, 50, 100, 500]"
        v-loading="loading"
      ></rabbey-table3>

      <EditEventFinances
        :openEditEvent="openEditEvent"
        :dataInvoices="dataInvoices2"
        @onClose="closeEditEventFinances"
      ></EditEventFinances>
    </el-drawer>
  </div>
</template>
<script>
import { Payments, Invoices } from "@/columns";
import { formatMonto } from "@/utils";
import EditEventFinances from "@/views/apps/calendar/EditEventFinances.vue";
import { ActionsInvoicesOrPayments } from "@/components/activity_flow/DialogLocker/InvoicesOrPaymentsFunctions.js";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import monthcomponent from "@/components/Global_System/MonthsComponent.vue";
export default {
  name: "InvoicesOrPayments",
  components: {
    EditEventFinances,
    yearcomponent,
    monthcomponent
  },
  props: {
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawer: false,
      loading: false,
      title: "",
      reportData: [],
      qty: 0,
      columns: [],
      dataDetails: [],
      countTotalPayments: 0,
      countTotalPaymentsPending: 0,
      countTotalPaymentsPaid: 0,
      countTotalInvoices: 0,
      ActionsInvoicesOrPayments,
      openEditEvent: false,
      dataInvoices2: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      search: "",
      tableRowClassName: ""
    };
  },
  created() {
    this.getReportData();
  },
  computed: {
    totalInvoices() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.dataDetails.length > 0) {
        amountArray = this.dataDetails.map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },

    totalInvoicesNotRecorded() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.dataDetails.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.dataDetails
          .filter((payment) => payment.Paid === false)
          .map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    totalPaymentsRecorded() {
      let totalAmount = 0;
      let amountArray = [];

      if (this.dataDetails.length > 0) {
        // amountArray = this.TableData.map((payment) => console.log("computed",payment))
        amountArray = this.dataDetails
          .filter((payment) => payment.Paid === true)
          .map((payment) => payment.Amount);

        if (amountArray.length > 0) {
          totalAmount = amountArray.reduce((prev, next) => prev + next);
        }
      }
      return formatMonto(totalAmount);
    },
    onTableData() {
      let tableData;
      if (this.title == "Facturas del mes sin registrar") {
        tableData = this.dataDetails.filter((td) => {
          let [yearF, monthF] = td.BillingDate.split("-");
          return monthF == this.month && yearF == this.year;
        });
        return tableData;
      } else {
        return this.dataDetails;
      }
    }
  },
  methods: {
    getReportData() {
      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetInvoicesOrPaymentsStat")
        .then((resp) => {
          this.reportData = resp.data;
          this.loading = false;
        });
    },

    GetDetailsData(option) {
      let Parameters = {
        params: {
          option: option
        }
      };
      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
        .then((response) => {
          switch (option) {
            case "A": {
              this.dataDetails = response.data[0].PaymentsMonth;
              this.countTotalPayments = response;
              break;
            }
            case "B": {
              this.dataDetails = response.data[0].PaymentsMonth;
              break;
            }
            // case "C": {
            //   this.dataDetails = response.data[0].PaymentsMonth;
            //   break;
            // }
            case "D": {
              this.dataDetails = response.data[0].PaymentsMonth;
              break;
            }
            case "E": {
              this.dataDetails = response.data[0].PaymentsMonth;
              break;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleClickLink(props) {
      this.title = props.Title;
      this.totalAmount = props.Qty;

      switch (props.Title) {
        case "Pagos del mes sin realizar": {
          this.columns = Payments;
          let option = "A";
          this.GetDetailsData(option);
          break;
        }
        case "Pagos pendientes meses anteriores": {
          this.columns = Payments;
          let option = "B";
          this.GetDetailsData(option);
          break;
        }
        // case "Pagos vencidos": {
        //   this.columns = Payments;
        //   let option = "C";
        //   this.GetDetailsData(option);
        //   break;
        // }

        case "Facturas del mes sin registrar": {
          this.columns = Invoices;
          let option = "D";
          this.GetDetailsData(option);
          break;
        }

        case "Facturas sin registrar meses anteriores": {
          this.columns = Invoices;
          let option = "E";
          this.GetDetailsData(option);
          break;
        }
      }
      this.drawer = true;
    },
    handlePushAction(row) {
      switch (row.command) {
        case "edit-eventFinaces": {
          this.dataInvoices2 = row.row;
          //this.dialogTitleEvent;
          this.openEditEvent = true;
          break;
        }
      }
    },
    closeEditEventFinances() {
      this.openEditEvent = false;
    },
    handler_year(_year) {
      this.year = _year;
    },
    handler_month(_month) {
      this.month = _month;
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    }
  }
};
</script>

<style scoped></style>
